import { faBabyCarriage } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { strollersUrl } from "@/mk2/apps/strollers/urls";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { HINT, STROLLERBASE_BANNER_TEXT } from "@/mk/autogenerated/translation";

import styles from "./StrollerbaseBanner.mscss";

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const StrollerbaseBanner = React.memo<Props>(({ className }) => (
    <Panel className={cx(styles.StrollerbaseBanner, className)}>
        <Link className={styles.StrollerbaseBanner__link} to={strollersUrl}>
            <span className={styles.StrollerbaseBanner__hint}>{HINT}: </span>
            <FontAwesomeIcon icon={faBabyCarriage} /> {STROLLERBASE_BANNER_TEXT}
        </Link>
    </Panel>
));

StrollerbaseBanner.displayName = "StrollerbaseBanner";

export default StrollerbaseBanner;
